export const formatCouncil = (medicalRegistrationNumberType?: string | null, medicalRegistrationNumber?: string | null): string => 
  [medicalRegistrationNumberType, medicalRegistrationNumber].filter(Boolean).join(': ') || '';
